import "./SiteFooter-style";
import "./SiteFooter-static.html";